import { getUnidadeMedidaCombo } from "@/utils/common/combo/combotext";

import UnidadeMedidaModel from "../models/unidadeMedidaModel";
import nfetch from "../utils/events/nfetch";

import { iServiceCached } from "./base/iServiceCached";

class UnidadeMedidaService extends iServiceCached<UnidadeMedidaModel> {
    constructor() {
        super("UnidadeMedida");
    }

    public async comboCached(franquiaId: number, forceRefresh = false) {
        const retorno = await this.combo(franquiaId, forceRefresh);
        return retorno.map(item => getUnidadeMedidaCombo(item));
    }

    public async converterUnidadeMedida(
        unidadeMedidaOrigemId: number,
        unidadeMedidaDestinoId: number,
        densidade = 1,
        produtoId = 0,
        produtoLoteId = 0,
    ) {
        return await nfetch(
            `/${this.controllerName}/ConverterUnidadeMedida?unidadeMedidaOrigemId=${unidadeMedidaOrigemId}&unidadeMedidaDestinoId=${unidadeMedidaDestinoId}&densidade=${densidade}&produtoId=${produtoId}&produtoLoteId=${produtoLoteId}`,
            {
                credentials: "same-origin",
            },
        )
            .withLoading()
            .resolveWithJSON<number>();
    }

    public getUnidadeMedidabySiglas(unidadeMedidaSigla: string) {
        return nfetch(`/${this.controllerName}/GetUnidadeMedidabySiglas?sigla=${unidadeMedidaSigla}`, {
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<UnidadeMedidaModel>();
    }
}

export default new UnidadeMedidaService();
